<template>
  <div class="time-picker-field">
    <!--   prepend-icon="mdi-clock-time-four-outline"-->
    <v-menu
      ref="menuTimeEndTime"
      v-model="showTimePicker"
      :close-on-content-click="false"
      :nudge-right="40"
      return-value.sync="time"
      transition="scale-transition"
      offset-y
      max-width="290"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          :value="value"
          @input="val => $emit('input', val)"
          clearable
          :label="label"

          readonly
          outlined
          v-bind="attrs"
          v-on="on"
          @click:clear="$emit('inpul', null)"
        ></v-text-field>
      </template>

      <v-card>
        <v-time-picker
          v-if="showTimePicker"
          v-model="timePickerValue"
          format="24hr"
        ></v-time-picker>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            @click="setTime"
            :disabled="!timePickerValue"
            depressed
          >
            ОК
          </v-btn>
          <v-btn
            @click="closeTimePicker"
            depressed
          >
            Отмена
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
  // import { mapGetters } from 'vuex'

  export default {
    name: 'TimePickerField',
    props: {
      value: {
        type: String,
        default: null,
      },
      label: {
        require: true,
        type: String,
      },
      loading: Boolean,
      disabled: Boolean,
    },

    data () {
      return {
        showTimePicker: false,
        timePickerValue: null,
      }
    },
    watch: {
      value (newValue) {
        this.timePickerValue = newValue
      },
    },
    methods: {
      closeTimePicker () {
        this.showTimePicker = false
        this.timePickerValue = this.value
      },
      setTime () {
        this.showTimePicker = false
        this.$emit('input', this.timePickerValue)
      },
    },
  }
</script>

<style scoped>

</style>
